import { Component, OnInit, Optional } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { PortalService } from "src/app/services/portal-service.service";

@Component({
  standalone: false,
  selector: "app-reset",
  templateUrl: "./reset.component.html",
  styleUrls: ["./reset.component.scss"],
})
export class ResetComponent implements OnInit {
  ResetForm: UntypedFormGroup;
  resetQuestion: string;
  error: any = null;
  success = false;
  gotQuestion = false;
  gettingQuestion = false;
  resetting = false;
  constructor(
    private fb: UntypedFormBuilder,
    private portalService: PortalService,
    private as: AuthService,
    private router: Router,
    @Optional() private dialogRef?: MatDialogRef<ResetComponent>,
  ) {}

  ngOnInit(): void {
    this.ResetForm = this.fb.group({
      resetQuestion: [{ value: "", disabled: true }],
      resetAnswer: [""],
      email: ["", [Validators.required, Validators.email]],
    });
  }

  async getResetQuestion() {
    this.resetMessage();
    if (this.gettingQuestion) return;
    this.gettingQuestion = true;
    try {
      const data: { question: string } = await this.portalService.getResetQuestion(this.ResetForm.controls.email.value);
      this.ResetForm.controls.resetQuestion.setValue(data.question);
      this.ResetForm.controls.resetAnswer.setValidators([Validators.required]);
      this.ResetForm.controls.resetAnswer.updateValueAndValidity();
      this.gotQuestion = true;
    } catch (error) {
      this.error = error;
    } finally {
      this.gettingQuestion = false;
    }
  }

  resetMessage() {
    this.success = false;
    this.error = null;
  }

  logout() {
    if (this.dialogRef) {
      this.dialogRef.close();
      return;
    }
    this.as.logout();
    this.router.navigate(["login"]);
  }

  async resetPassword() {
    this.resetMessage();
    if (this.resetting) return;
    this.resetting = true;
    try {
      await this.portalService.resetPassword(this.ResetForm.controls.email.value, this.ResetForm.controls.resetAnswer.value);
      this.success = true;
    } catch (error) {
      this.error = error;
    } finally {
      this.resetting = false;
    }
  }

  get f() {
    return this.ResetForm.controls;
  }

  close(): void {
    this.dialogRef?.close();
  }

  nextDisabled(): boolean {
    return this.gettingQuestion || !this.f.email.value || this.f.email.invalid;
  }

  resetDisabled(): boolean {
    return this.resetting || !this.f.resetAnswer.value || this.f.resetAnswer.invalid || !this.f.email.value || this.f.email.invalid;
  }
}
